import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {ApplicationModel, parseApplication, RApplication} from './applicationModel';

/*
 * Runtime types.
 */

const RSearchApplicationsDirty = t.readonly(
  t.type({
    items: t.readonlyArray(RApplication),
    total: t.number,
    limit: t.number,
  }),
);

/*
 * Types.
 */

export type SearchApplicationModel = ReadonlyArray<ApplicationModel>;
export interface SearchApplicationsModel extends t.TypeOf<typeof RSearchApplicationsDirty> {}
export const RSearchApplications = t.clean<SearchApplicationsModel>(RSearchApplicationsDirty as any);

/*
 * IO methods.
 */

function parseSearchApplications(src: any): SearchApplicationsModel {
  return {
    items: src.items.map(parseApplication),
    total: src.total,
    limit: src.limit,
  };
}

/*
 * API type.
 */

export const ApiSearchApplications = makeApiType(
  'searchApplications',
  RSearchApplications,
  parseSearchApplications,
);
